import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggle } from 'store/siteMenu'
import { listServices } from 'store/listedServices'

import WPAPI from 'wpapi'
import { Link } from 'react-router'

import PropTypes from 'prop-types'

import { Power0, Power2, TweenMax } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
import $ from 'jquery'

import './index.scss'
import ArrowLeft from 'assets/images/arrow-left.svg'

import { relativizeURL, rootPath, decode, createMarkup } from 'lib/Utils'

const panelBits = 'li, .menu-panel__title, .menu-panel__back'

class SiteMenu extends Component {
  constructor (props) {
    super(props)
    this.state = { menuItems: [] }
    this.timeline = new TimelineMax()
    this.panels = []
    this.panelElements = {}
    this.menuItemTitles = {}
    this.discoverPanels = this.discoverPanels.bind(this)
    this.activePanel = null
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  componentDidMount () {
    // Need to change endpoint depending on environment
    const wp = new WPAPI({
      endpoint: `${rootPath}/wp-json`
    })
    wp.menuLocation = wp.registerRoute('wp-api-menus/v2', '/menu-locations/(?P<location>[a-zA-Z0-9_-]+)')
    wp.menuLocation().location('primary_navigation').get().then(menuItems => {
      this.discoverPanels(menuItems)
      this.setState({ menuItems })
    })

    $('body').on('keydown', this.closeOnEscape)
  }

  componentWillUnmount () {
    $('body').off('keydown', this.closeOnEscape)
  }

  closeOnEscape (event) {
    if (event.key === 'Escape' && this.props.visible) {
      this.props.toggle(false)
    }
  }

  goToPanel (event, parentID, fwd) {
    event.preventDefault()
    let panelToGo = this.panelElements[parentID]
    let $panelToGo = $(panelToGo)
    let $activePanel = $(this.activePanel)
    let dir = (fwd) ? 1 : -1

    $panelToGo.scrollTop(0)

    this.timeline
      .clear()
      .set($panelToGo, { autoAlpha: 1 })
      .staggerTo($activePanel.find(panelBits), 0.5, {
        autoAlpha: 0,
        rotationY: (30 * -1 * dir) + 'deg',
        ease: Power2.easeInOut,
        onComplete: function (panel) {
          setTimeout(function () {
            TweenMax.set(panel, { autoAlpha: 0 })
            TweenMax.set(panel.find(panelBits), { rotationY: '0px' })
          }, 200)
        },
        onCompleteParams: [$activePanel]
      }, 0.05, 0)
      .staggerFromTo($panelToGo.find(panelBits), 0.5,
        { autoAlpha: 0, rotationY: (30 * dir) + 'deg' },
        { autoAlpha: 1, rotationY: '0deg', ease: Power2.easeInOut },
        0.05, 0.2)

    this.activePanel = panelToGo
  }

  createMenuItems (items) {
    return (
      items.map(function (item) {
        return (
          <li key={item.ID}>
            {this.createLink(item)}
          </li>
        )
      }, this)
    )
  }

  createLink (item) {
    let title = decode(item.title)
    if (item.children.length === 0) {
      return <Link to={relativizeURL(item.url)} dangerouslySetInnerHTML={createMarkup(title)} />
    } else {
      return (
        <a href='#'
          onClick={(event) => this.goToPanel(event, item.ID, true)}
          dangerouslySetInnerHTML={createMarkup(title)} />
      )
    }
  }

  renderPanels (menuItems) {
    if (this.panels.length === 0) {
      return ''
    }
    return this.panels.map((panel, i) => {
      let parent = panel[0].parent
      return (
        <div key={`panel${parent}`} ref={el => {
          this.panelElements[parent] = el
          if (i === 0) {
            this.activePanel = (this.activePanel) ? this.activePanel : this.panelElements[parent]
          }
        }} className='menu-panel faded'>
          <div className='menu-panel__inner'>
            {
              (parent !== 0)
              ? <a href='#' onClick={(event) => this.goToPanel(event, this.menuItemTitles[parent].parent, false)} className='menu-panel__back'>
                <img src={ArrowLeft} alt='back' />
              </a>
              : ''
            }
            <div className='menu-panel__title'>{ (parent !== 0) ? decode(this.menuItemTitles[parent].title) : 'MENU'}</div>
            <ul className='menu-panel__vlist'>{this.createMenuItems(panel)}</ul>
          </div>
        </div>
      )
    })
  }

  discoverPanels (menuItems) {
    if (menuItems[0].parent === 35) {
      this.props.listServices(menuItems.map((item) => {
        return {
          ID: item.object_id,
          title: item.title,
          url: item.url,
          key: item.description
        }
      }))
    }
    this.panels.push(menuItems)
    menuItems.forEach(function (item) {
      this.menuItemTitles[item.ID] = { title: item.title, parent: item.parent }
      if (item.children.length > 0) {
        this.discoverPanels(item.children)
      }
    }, this)
  }

  render () {
    return (
      <nav ref={el => { this.el = el }} className='site-menu faded'>
        {this.renderPanels(this.state.menuItems)}
      </nav>
    )
  }

  componentDidUpdate (prevProps) {
    if (
      (
        // if they're both services but a different service.
        (
          prevProps.content.title === this.props.content.title &&
          prevProps.content.item !== undefined &&
          this.props.content.item !== undefined &&
          prevProps.content.item.id !== this.props.content.item.id
        ) ||
        // if they are different pages
        prevProps.content.title !== this.props.content.title
      ) &&
      this.props.visible
    ) {
      this.props.toggle(false)
      // this.pageLayout.render()
      return
    }

    if (prevProps.visible === this.props.visible) {
      return
    }

    let $menu = $(this.el)
    let $activePanel = $(this.activePanel)
    if (this.props.visible) {
      TweenMax.set($menu.find('.menu-panel'), { autoAlpha: 0 })

      this.timeline
        .clear()
        .set($activePanel, { autoAlpha: 1 })
        .to($menu, 0.6, { autoAlpha: 1, ease: Power0.easeNone })
        .staggerFromTo(
          $activePanel.find(panelBits),
          0.5,
          { autoAlpha: 0, y: '60px' },
          { autoAlpha: 1, y: '0px', ease:  Power2.easeInOut },
          0.05,
          0
         )
    } else {
      this.timeline
        .clear()
        .to($menu, 0.3, {
          autoAlpha: 0,
          ease: Power0.easeNone,
          onComplete: () => {
            this.activePanel = this.panelElements['0']
          }
        }, 0)
        // .staggerTo(
        //   $activePanel.find(panelBits),
        //   0.5,
        //   { autoAlpha: 0, rotationX: '10deg', ease: Power2.easeInOut },
        //   0.05,
        //   0
        //  )
    }
  }
}

const mapStateToProps = (state) => ({
  visible: state.siteMenuVisible,
  path: state.location.pathname,
  content: state.content
})

const mapDispatchToProps = {
  toggle : (visibility) => toggle(visibility),
  listServices : (services) => listServices(services)
}

SiteMenu.propTypes = {
  visible: PropTypes.bool,
  path: PropTypes.string,
  toggle: PropTypes.func,
  listServices: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteMenu)



// WEBPACK FOOTER //
// ./src/containers/SiteMenu/index.js